export function removeCO2Items(data) {
  return data.map((category) => ({
    ...category,
    items: category.items.filter((item) => !item.includes("CO₂"))
  }));
}
